import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as PropTypes from 'prop-types';
import messageActions from '../../store/actions/messageActions';
import productActions from '../../store/actions/productActions';
import IconModalClose from './Icons/IconModalClose';

const Modal = ({
  className,
  modalWidth,
  modalTitle,
  modalTrigger,
  onSubmitLabel,
  onSubmit,
  onCancelLabel,
  onCancel,
  children,
  sendSuccess,
  buttonDisabled,
  isOpen,
  hideFooter = false,
  closeOnSubmit = false,
}) => {
  const dispatch = useDispatch();
  const [isModalShown, toggleModal] = useState(false);

  const showModal = () => {
    toggleModal(true);
    document.body.style.overflow = 'hidden';
  };

  const hideModal = () => {
    document.body.style.overflow = '';
    toggleModal(false);

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  const closeModal = () => {
    document.body.style.overflow = '';
    toggleModal(false);

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  const onSubmitClick = (e) => {
    onSubmit(e);

    if (closeOnSubmit) {
      closeModal();
    }
  };

  useEffect(() => {
    if (sendSuccess) {
      hideModal();
      dispatch(messageActions.sendMessageDiscard());
      dispatch(productActions.sendProductComplaintDiscard());
    }
  }, [sendSuccess]);

  return (
    <div className={`modal ${className}`}>
      {modalTrigger && (
        <div className={`modal-trigger`} onClick={() => showModal()}>
          {modalTrigger}
        </div>
      )}
      {
        isOpen || isModalShown
          ? (
            <>
              <div
                className="modal-underlay"
                onClick={() => hideModal()}
              />

              <div className="modal-content-wrapper">
                <div
                  className="modal-content"
                  style={{ width: `${modalWidth}px` }}
                >
                  <div className="modal-content__inner">
                    <div className="modal-content__header">
                      <div className="modal-content__header__title">
                        {modalTitle}
                      </div>
                      <IconModalClose
                        onClick={() => closeModal()}
                      />
                    </div>
                    <div className="modal-content__body">
                      {children}
                    </div>
                    {!hideFooter && (
                      <div className="modal-content__footer">
                        <button
                          type="button"
                          className="button primary"
                          onClick={onSubmitClick}
                          disabled={buttonDisabled}
                        >
                          {onSubmitLabel}
                        </button>
                        {onCancelLabel && (
                          <button
                            type="button"
                            className="button red"
                            onClick={hideModal}
                          >
                            {onCancelLabel}
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )
          : null
      }
    </div>
  );
};

Modal.propTypes = {
  modalWidth: PropTypes.number,
  modalTitle: PropTypes.string,
  modalTrigger: PropTypes.object,
  onSubmitLabel: PropTypes.string,
  onCancelLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  sendSuccess: PropTypes.bool,
  isOpen: PropTypes.bool,
};

Modal.defaultProps = {
  modalWidth: 580,
  modalTitle: '',
  onSubmitLabel: 'Send',
  onSubmit: () => { },
  onCancel: () => { },
  sendSuccess: false,
};

export default Modal;
